import { Base } from '@studiometa/js-toolkit';
import Vue from 'vue';
import MapboxContainer from './map-container.vue';
import store from './store/index.js';

/**
 * Map
 */
export default class GeoPinsMap extends Base {
  /**
   * mounted
   */
  static config = {
    name: 'GeoPinsMap',
    refs: ['vue'],
    // Default value to center on Epernay city
    options: {
      lat: {
        type: Number,
        default: 49.043411,
      },
      lng: {
        type: Number,
        default: 3.956242,
      },
      url: {
        type: String,
        default: '',
      },
      endpointGeojson: {
        type: String,
        default: '',
      },
      endpointResults: {
        type: String,
        default: '',
      },
      endpointMainFilters: {
        type: String,
        default: '',
      },
      endpointSecondaryFilters: {
        type: String,
        default: '',
      },
      i18n: {
        type: Object,
        default: () => {},
      },
    },
  };

  /**
   * Formatted center for the map
   * @returns {Array}
   */
  get center() {
    return [this.$options.lng, this.$options.lat];
  }

  /**
   * Mounted
   */
  mounted() {
    this.vue = new Vue({
      el: this.$refs.vue,
      store,
      render: (h) =>
        h(MapboxContainer, {
          props: {
            center: this.center,
            url: this.$options.url,
            i18n: this.$options.i18n,
            endpoints: {
              geojson: this.$options.endpointGeojson,
              results: this.$options.endpointResults,
              mainFilters: this.$options.endpointMainFilters,
              secondaryFilters: this.$options.endpointSecondaryFilters,
            },
          },
        }),
    });
  }
}
